__webpack_require__.p = "https://images-cdn-staging.curipod.com/d-2ba5de11/_next/";